import { getStoreUrl, getStoreCode, buildUrl } from ".";

const getBaseUrl = ({ state }) => {
  const storeUrl = getStoreUrl(state);
  const storeCode = getStoreCode(state);

  return buildUrl({ storeCode, storeUrl }, null);
};

export default getBaseUrl;
